import { View } from 'react-native'
import { globalStyles } from '../../../static/styles/global'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'
import { usePersonalStore } from '../../../stores/personalInfo'
import { useFormsStore } from '../../../stores/onboarding'
import { useInitializeStore } from '../../../stores/initialize'
import Toast from 'react-native-toast-message'
import SignatureFormView from '../SignatureFormView'

const ScInformationOnline = ({ navigation, route }: any) => {
    const {
        values,
        essUserOnBoardingKey,
        essUserOnBoardingFormKey,
    } = route.params


    const personalstore = usePersonalStore()
    const intializeStore = useInitializeStore()
    const { loading, postsconline } = useFormsStore()



    const data = {
        entityId: personalstore?.personalData?.entityId,
        essUserKey: intializeStore?.initializeData?.userkey,
        essObKey: essUserOnBoardingKey,
        essUserOnBoardingFormKey: essUserOnBoardingFormKey,
        completeOnline: true,
        martialStatus: values?.maritalstatus,
        checkSsc: values?.checkssc === 0 ? values?.checkssc : null,
        totalAllowances: values?.totalallowances ? values?.totalallowances : null,
        additionalAmount: values?.additionalamount ? values?.additionalamount : null,
        claimExempt: values?.claimexempt,
        rightToRefund: values?.righttorefund === 0 ? values?.righttorefund : null,
        militaryService: values?.righttorefund === 1 ? 0 : null,
        stateOfDomicile: values?.stateofdomicile,

    }

    const handlesubmit = async (signatureDataURL: any) => {
        const payload = { ...data, sign: signatureDataURL }
        const response: any = await postsconline(payload)
        if (response?.success === true) {
            await Toast.show({
                type: 'success',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60,
                onHide: () => {
                    navigation.replace('OnboardingForms')
                }
            })
        } else {
            await Toast.show({
                type: 'error',
                position: 'bottom',
                text1: response?.message,
                visibilityTime: 3000,
                autoHide: true,
                topOffset: 60
            })
        }
    }

    return (
        <>
            <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
                <View style={[globalStyles.horizontalPadGap]}>
                    <HomeDetailsHeader
                        navLabel="Forms"
                        navScreen="OnboardingForms"
                        title={'SC Withholding Taxation'}
                    />
                </View>
            </View>
            <SignatureFormView
                essUserOnBoardingFormKey={essUserOnBoardingFormKey}
                essUserOnBoardingKey={essUserOnBoardingKey}
                isSubmitting={loading}
                onPrevious={() =>
                    navigation.navigate('ScInformationForm', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey,
                        values,
                        mode: "online",

                    })
                }
                onSubmit={handlesubmit}
            />
        </>
    )
}

export default ScInformationOnline
